import React from 'react';
import { Helmet } from 'react-helmet-async';
import { usePageTitle } from '@hooks/usePageTitle';

interface PageHeadProps {
    title?: string;
    description?: string;
    keywords?: string;
    useDynamicTitle?: boolean;
}

export const PageHead: React.FC<PageHeadProps> = ({
    title: propTitle,
    description: propDescription,
    keywords = 'upercut, cms, recrutement, gestion, emploi',
    useDynamicTitle = false
}) => {
    const dynamicPageData = usePageTitle();

    // Use dynamic title if enabled and no explicit title provided, otherwise use prop title
    const title = useDynamicTitle && !propTitle
        ? dynamicPageData.title
        : propTitle || dynamicPageData.title;

    const description = propDescription || dynamicPageData.description ||
        'Upercut CMS - Plateforme de gestion de contenu pour les professionnels du recrutement';

    return (
        <Helmet>
            <title>{title} | Upercut CMS</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta property="og:title" content={`${title} | Upercut CMS`} />
            <meta property="og:description" content={description} />
            <meta name="twitter:title" content={`${title} | Upercut CMS`} />
            <meta name="twitter:description" content={description} />
        </Helmet>
    );
};

export default PageHead;
